// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__23dSU","noBorder":"Card_noBorder__p9E3r"};